var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"text-primary title-text"},[_vm._v(_vm._s(_vm.propsData.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }